import { ClosedAccountingDocumentStatuses } from '@/constants/accounting.constants';
import { type AccountingDocument } from '@/models/accounting-document.model';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useAccountingDocumentsStore = defineStore('accounting-documents', () => {
  // state
  const openAccountingDocuments = ref<AccountingDocument[]>([]);
  const closedAccountingDocuments = ref<AccountingDocument[]>([]);

  // getters
  const openDocuments = computed<AccountingDocument[]>(() => openAccountingDocuments.value);
  const closedDocuments = computed<AccountingDocument[]>(() => closedAccountingDocuments.value);

  // actions
  function setAccountingDocuments(documents: AccountingDocument[]) {
    const openDocs: AccountingDocument[] = [];
    const closedDocs: AccountingDocument[] = [];

    for (const document of documents) {
      if (ClosedAccountingDocumentStatuses.includes(document.status)) {
        closedDocs.push(document);
      } else {
        openDocs.push(document);
      }
    }

    openAccountingDocuments.value = openDocs;
    closedAccountingDocuments.value = closedDocs;
  }

  function $reset() {
    closedAccountingDocuments.value = [];
    openAccountingDocuments.value = [];
  }

  return {
    openDocuments,
    closedDocuments,
    setAccountingDocuments,
    $reset,
  };
});
